ko.bindingHandlers['sortable'] = {
    init: (element, valueAccessor) => {
        var modelValue = valueAccessor(),
            unwrappedValue = ko.utils.peekObservable(modelValue);

        var data = unwrappedValue['data'],
            itemSelector = unwrappedValue['items'],
            handleSelector = unwrappedValue['handle'],
            changed = unwrappedValue['changed'];

        var placeholder;
        var source;

        function indexOf(list, item) {
            return Array.from(list).indexOf(item);
        }

        if (handleSelector) {
            element.addEventListener("mousedown", e => {
                const handle = e.target.closest(handleSelector);
                if (handle) {
                    var item = handle.closest(itemSelector);
                    item.setAttribute('draggable', 'true');
                }
            });

            element.addEventListener("mouseup", e => {
                const handle = e.target.closest(handleSelector);
                if (handle) {
                    var item = handle.closest(itemSelector);
                    item.removeAttribute('draggable');
                }
            });
        }

        element.addEventListener("dragstart", e => {
            source = e.target;

            e.stopImmediatePropagation();
            if (source.getAttribute('draggable') !== 'true') {
                return false;
            }

            element.classList.add("sortable");

            var item = ko.dataFor(source),
                index = data.indexOf(item);
            e.dataTransfer.setData("itemIndex", index);

            placeholder = source.cloneNode(true);
            placeholder.classList.add("sortable-ph");

            setTimeout(() => {
                source.parentElement.insertBefore(placeholder, source.nextElementSibling);
                source.style.display = 'none';
            }, 10);

            element.classList.add("is--sorting");
            sorting = true;

            console.log("drag start");
        });

        element.addEventListener("dragend", e => {
            var source = e.target;

            source.style.display = 'block';

            if (placeholder) {
                placeholder.remove();
                placeholder = null;
            }

            sorting = false;
            element.classList.remove("is--sorting");
            console.log("drag end");
        });

        element.addEventListener("dragover", e => {
            var target = e.target.closest(itemSelector);
            if (!target) {
                e.preventDefault();
                return false; 
            }

            console.log("moving placeholder");

            var phIndex = indexOf(target.parentElement.children, placeholder);
            var targetIndex = indexOf(target.parentElement.children, target);

            placeholder.remove();

            if (phIndex > targetIndex) {
                target.parentElement.insertBefore(placeholder, target);
            } else {
                target.parentElement.insertBefore(placeholder, target.nextElementSibling);
            }

            return true;
        });

        element.addEventListener("drop", e => {
            var index = e.dataTransfer.getData("itemIndex");
            var phIndex = indexOf(e.target.children, placeholder);

            source.style.display = 'block';
            var item = data.splice(index, 1)[0];

            var newIndex = phIndex;
            if (index < phIndex) {
                newIndex = phIndex - 1;
            } 

            data.splice(newIndex, 0, item);

            if (placeholder) {
                placeholder.remove();
                placeholder = null;
            }

            if (changed && typeof changed === 'function') {
                changed(index, newIndex);
            }
        });

        return { 'controlsDescendantBindings': false };
    }
};